import { render, staticRenderFns } from "./LayMenu.vue?vue&type=template&id=84542978&"
import script from "./LayMenu.vue?vue&type=script&lang=js&"
export * from "./LayMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports